import { render } from "./Galery.vue?vue&type=template&id=623d9772"
import script from "./Galery.vue?vue&type=script&lang=js"
export * from "./Galery.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__